import { PaginationQueries } from 'types/search.type';
import { ExperienceDetail } from './experience-detail.type';
import {
  ExperienceSession,
  ExperienceSessionExtraPrice,
} from './experience-session.type';
import { ExperiencePrice } from './experience-util.type';

export enum ExperienceTicketState {
  CREATED = 'CREATED',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  WAITING_DUE_DATE = 'WAITING_DUE_DATE',
  ON_GOING = 'ON_GOING',
  EXPIRED = 'EXPIRED',
  CANCELLED = 'CANCELLED',
  DONE = 'DONE',
}

export interface ExperienceTicketsGetPayload {
  startDate: string;
  endDate: string;
  state?: ExperienceTicketState[];
  pagination: PaginationQueries;
}

export interface ExperienceTicketCreateExtra {
  sessionExtraId: number;
}

export interface ExperienceTicketExtra {
  count: number;
  description: string;
  sessionExtraId: number;
  title: string;
  totalPrice: ExperienceSessionExtraPrice;
  unitPrice: ExperienceSessionExtraPrice;
}

export interface ExperienceTicketCreatePayload {
  ticketCount: number;
  totalPrice: number;
  sessionId: number;
  experienceId: number;
  selectedExtras: ExperienceTicketCreateExtra[];
}

export interface ExperienceTicketDetail extends ExperienceDetail {
  selectedSession: ExperienceSession;
}

export interface ExperienceTicket {
  createdAt: string;
  ticketId: number;
  ticketAmount: number;
  price: ExperiencePrice;
  totalPrice: number;
  sessionId: number;
  state: ExperienceTicketState;
  experienceDetail: ExperienceTicketDetail;
  partnerPhone: string;
  freeCancellable: boolean;
  extras: ExperienceTicketExtra[];
}

export interface ExperienceTicketCancelPayload {
  reason: string;
}
